export default __webpack_public_path__ + "static/media/606.85fe6ce1.svg";